module.exports = __webpack_public_path__ + "img/x5.cb215663.jpg";